<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-FenXiang1`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_3750e55ce5__clip0_18957_6717)"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.0501 1.70515C12.4787 1.13768 11.5067 1.54897 11.516 2.35427L11.5699 6.97189C5.95406 7.29663 1.34888 10.7038 1.74497 21.9665C1.76782 22.6161 2.777 22.7823 3.07231 22.2032C4.49884 19.406 7.29776 15.354 11.6117 15.1407L11.5477 19.7094C11.5366 20.5038 12.4851 20.9219 13.064 20.3778L21.9634 12.014C22.3757 11.6265 22.3847 10.9744 21.9832 10.5757L13.0501 1.70515ZM20.1506 11.0815L13.2221 4.15955V7.42915C13.2221 8.00025 12.7442 8.45105 12.1732 8.46299C8.03051 8.5496 3.95658 10.4863 3.41044 18.1565C3.41044 18.1565 6.29091 13.5819 12.251 13.2607C12.7928 13.2315 13.2284 13.6798 13.2284 14.2224V17.636L20.1506 11.0815Z"/></g><defs><clipPath id="svg_3750e55ce5__clip0_18957_6717"><path d="M0 0H24V24H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconFenXiang1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
